import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../components/WebView/icons/BackLeftAction.svg'


const _withScopeId = n => (_pushScopeId("data-v-14b55921"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "AskNicely"
}, null, -1))
const _hoisted_2 = [
  _hoisted_1
]
const _hoisted_3 = ["disabled"]
const _hoisted_4 = { class: "expand" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MentionableEditor = _resolveComponent("MentionableEditor")!
  const _component_WebViewForm = _resolveComponent("WebViewForm")!
  const _component_WebViewScreen = _resolveComponent("WebViewScreen")!

  return (_openBlock(), _createBlock(_component_WebViewScreen, {
    title: _ctx.displayTitle,
    "no-pad": ""
  }, {
    "left-button": _withCtx(() => [
      _createElementVNode("div", {
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
      }, _hoisted_2)
    ]),
    "right-button": _withCtx(() => [
      _createElementVNode("div", {
        class: "submit",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.submitAction && _ctx.submitAction(...args)))
      }, [
        _createElementVNode("button", {
          disabled: !_ctx.submittable
        }, "Post", 8, _hoisted_3)
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_WebViewForm, { onSubmit: _ctx.submitAction }, {
        default: _withCtx(() => [
          _createElementVNode("fieldset", _hoisted_4, [
            _createElementVNode("label", null, _toDisplayString(_ctx.textAreaLabel), 1),
            _createVNode(_component_MentionableEditor, {
              members: _ctx.suggestionMentionUsers,
              placeholder: _ctx.textAreaPlaceholder,
              text: _ctx.body,
              compacted: true,
              onInput: _ctx.onInputChange,
              onMention: _ctx.onMention
            }, null, 8, ["members", "placeholder", "text", "onInput", "onMention"])
          ])
        ], undefined, true),
        _: 1
      }, 8, ["onSubmit"])
    ], undefined, true),
    _: 1
  }, 8, ["title"]))
}